import styles from '../../assets/styles/Modal/NotificationModal.module.scss';
import { motion } from 'framer-motion';
import React from 'react';

const NotificationModal = ({ children, closeModal, goBack, ...props }) => {
	return (
		<motion.div
			initial={{
				opacity: 0,
			}}
			animate={{
				opacity: 1,
				transition: {
					duration: 0.2,
				},
			}}
			exit={{
				opacity: 0,
				transition: {
					duration: 0.2,
				},
			}}
			className={styles.background}
			onClick={closeModal}>
			<motion.div
				initial={{
					y: -100,
				}}
				animate={{
					y: 0,
					transition: {
						duration: 0.2,
					},
				}}
				exit={{
					y: 100,
					transition: {
						duration: 0.5,
					},
				}}
				className={styles.container}
				onClick={e => {
					e.stopPropagation();
				}}>
				<div className={styles.content}>{children}</div>
			</motion.div>
		</motion.div>
	);
};

export default NotificationModal;
